import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VaultenExperience from "@/components/VaultenExperience";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<VaultenExperience />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
